import { Component, OnInit } from '@angular/core';
import { DataStateChangeEvent, GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { 
  ExtUsersService,
  SharedDataService,
  PafListsService,
  PS_Search_Suppliers_Result,
  SupplierStatut
} from 'ngx-paf-common';
import { ActivatedRoute, Router } from '@angular/router';
import { ExcelExportData } from "@progress/kendo-angular-excel-export";


import {
  CellClickEvent,
} from "@progress/kendo-angular-grid";
import * as moment from 'moment';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-suppliers-list',
  templateUrl: './suppliers-list.component.html',
  styleUrls: ['./suppliers-list.component.scss']
})
export class SuppliersListComponent implements OnInit {

  get excelExportFileName(): string {
    let curDate: string =moment().format('DD-MM-YYYY HH-mm');
    return 'Liste fournisseurs ' + curDate + '.xlsx';
  }
  
  constructor(
    private extUserSvc:ExtUsersService,
    private route: ActivatedRoute,
    private router: Router,
    private extUsersSvc: ExtUsersService,
    private pafListsSvc:PafListsService,
    public sharedDataSvc: SharedDataService) { 
      this.allData = this.allData.bind(this);
    }

    lstSupplierStatuts:SupplierStatut[]=[];

  public suppliers:PS_Search_Suppliers_Result[];
  public gridData: GridDataResult;
  public state:State = {
    skip:0,
    take:10
  };


  ngOnInit(): void {
    this.pafListsSvc.getSupplierStatuts()
    .subscribe(res=>{
      this.lstSupplierStatuts = res;
      if (!this.sharedDataSvc.dashboardAlreadyShown){
        this.sharedDataSvc.dashboardAlreadyShown=true;
        this.redirectToScreenIfUniqueSupplier();
      } else{
        this.search();
      }
    });
  }

  get StatutSuspendu():SupplierStatut | undefined {
    return this.lstSupplierStatuts.find(st=>st.Cod=='900');
  }

  redirectToScreenIfUniqueSupplier(): void {
    this.extUsersSvc.getLoggedUserSuppliers()
      .subscribe((res: PS_Search_Suppliers_Result[]) => { 
        // On supprime les suspendus pour vérifier qu'il reste un fournisseur
        res = res.filter(fou=>fou.StatutId!=this.StatutSuspendu?.Id);       
        if (res.length == 1) {
          this.router.navigate([`supplier-details/${res[0].Id}`]);
          return;
        } else {
          this.search();
        }
      }, err=>{
        this.sharedDataSvc.alert(err);
      });
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridData = process(this.suppliers, this.state);
  }
  
public reinit(){
      this.suppliers = [];
      this.state = {
        skip:0,
        take:10
      };
      this.gridData = process(this.suppliers, this.state);
}

  public search(): void {
    this.sharedDataSvc.WindowLock();
    this.extUserSvc.getLoggedUserSuppliers()
    .subscribe((res: PS_Search_Suppliers_Result[]) => {
      this.suppliers = res;
      if ((this.state.skip || 0)>res.length){
        this.state={
          skip:0,
          take:10
        };
      }
      this.gridData = process(this.suppliers, this.state);
      this.sharedDataSvc.WindowUnlock();
      if ((!this.sharedDataSvc.dashboardAlreadyShown))
      {
        this.sharedDataSvc.dashboardAlreadyShown = true;
        let defaultLanguage:string='FR';
        if (res.find(s=>s.LngCod=='EN') && !res.find(s=>s.LngCod=='FR')){
          defaultLanguage='EN';
        }
        this.sharedDataSvc.changeLanguage(defaultLanguage);
        if (res.length==1){
          this.sharedDataSvc.WindowUnlock();
          this.router.navigate([`supplier-details/${ res[0].Id}`]);
        }
      }
      this.sharedDataSvc.WindowUnlock();
    });
  }

  isSiegeDisplay(item:PS_Search_Suppliers_Result): Observable<string>{
      return this.sharedDataSvc.getLabel((item.HQSiret||'')=='' ? 'Oui': 'Non');
  }

  getUniqueNum (item:PS_Search_Suppliers_Result): string{
    let key = Object.keys(item).find(k=> (k||'').toLowerCase()== (item.FunctionalId||'').toLowerCase());
    return key ? (<any>item)[key] : "";
  }

  public editSupplier(event:CellClickEvent):void{
    this.router.navigate([`supplier-details/${event.dataItem.Id}`]);
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.suppliers, {
        sort: [{ field: "SupplierName", dir: "asc" }],
      }).data
    };
    return result;
  }

  exportToExcel(grid: GridComponent){
    grid.saveAsExcel();
  }

}
